const ja = {
  subMenu: {
    managementScreenUserRegistration: '管理画面ユーザー登録',
    accountManagement: 'アカウント管理',
    userManagement: 'ユーザー管理',
    order: 'オーダー',
    itemInformation: '商品情報',
    itemImageUpload: '商品画像アップロード',
    searchConfig: '検索設定',
    category: 'カテゴリー',
    menu: 'メニュー',
    price: '価格',
    ad: '広告',
    recommendOnOrder: '注文時レコメンド',
    timedRecommend: '時限式レコメンド',
    eventInformation: 'イベント情報',
    eventList: 'イベント一覧',
    operationalManagement: '運用管理',
    allShopsConfig: '全店一括設定',
    shopList: '店舗一覧',
    groupConfig: 'グループ設定',
    'sumahoDeBikkurapon-jp': 'スマホでビッくらポン',
    sumahoDeBikkurapon: 'サイドメニュービッくらポン',
    sumahoDeBikkuraponConfig: 'スマホでビッくらポン設定',
  },
  common: {
    language: '言語',
    create: '新規登録',
    csvUpload: 'CSVアップロード',
    csvDownload: 'CSVダウンロード',
    displayCount: '表示件数',
    search: '検索',
    itemCode: '商品コード',
    itemName: '商品名',
    itemNameJapanese: '商品名（日本語）',
    itemNameEnglish: '商品名（英語）',
    itemNameTraditionalChinese: '商品名（繁体中国語）',
    itemNameSimplifiedChinese: '商品名（簡体中国語）',
    itemNameKorean: '商品名（韓国語）',
    calorie: 'カロリー',
    calorieUnit: 'kcal',
    manufacturingCategory: '製造区分',
    topping: 'トッピング',
    image: '画像',
    normalImage: '通常画像',
    wideImage: 'ワイド画像',
    normal: '通常',
    wide: 'ワイド',
    edit: '編集',
    totalCount: '総件数',
    itemUnit: '件',
    back: '戻る',
    inputComplete: '入力完了',
    csvFile: 'CSVファイル',
    import: '参照',
    upload: 'アップロード',
    imageUpload: '画像アップロード',
    csvFileUploadDescription: '5MBまでのcsvファイルをアップロードできます。',
    fileName: 'ファイル名',
    status: 'ステータス',
    uploadDate: 'アップロード日',
    importStartTime: '取込開始日時',
    importEndTime: '取込終了日時',
    delete: '削除',
    categoryId: 'カテゴリーID',
    categoryName: 'カテゴリー名',
    categoryNameJapanese: 'カテゴリー名（日本語）',
    categoryNameEnglish: 'カテゴリー名（英語）',
    categoryNameTraditionalChinese: 'カテゴリー名（繁体中国語）',
    categoryNameSimplifiedChinese: 'カテゴリー名（簡体中国語）',
    categoryNameKorean: 'カテゴリー名（韓国語）',
    save: '保存',
    implementationGroup: '実施グループ',
    implementationTiming: '実施タイミング',
    menuOnOrder: '注文時メニュー',
    recommend: 'レコメンド',
    recommendMenu: 'レコメンドメニュー',
    startTime: '開始日時',
    endTime: '終了日時',
    eventName: 'イベント名',
    conditionBranch: '条件分岐',
    behavior: '動作',
    shopName: '店舗名',
    shopId: '店舗ID',
    select: '選択',
    unselected: '未選択',
    operation: '運用',
    stop: '停止',
    setting: '設定',
    cancel: 'キャンセル',
    add: '追加',
    display: '表示',
    hidden: '非表示',
    yen: '円',
    twGen: '元',
    cnGen: '元',
    dollar: '{price}ドル',
    isSuccess: 'に成功しました。',
    isFailure: 'に失敗しました。',
    hasRegistered: 'を登録しました。',
    hasNotRegistered: 'の登録に失敗しました。',
    hasUpdated: 'を更新しました。',
    hasNotUpdated: 'の更新に失敗しました。',
    backToHome: 'ホーム画面に戻る',
  },
  commonCsvUpload: {
    processWaiting: '処理待',
    processing: '処理中',
    imported: '取込済',
    error: 'エラー',
  },
  loginPage: {
    loginPageName: 'スマホで注文管理画面ログイン',
    login: 'ログイン',
    orderWithTheSmartphone: 'スマホで注文',
  },
  accountManagementPage: {
    userList: 'ユーザー一覧',
    userName: 'ユーザー名',
    userId: 'ユーザーID',
    userRegistration: 'ユーザー登録',
    emailAddress: 'メールアドレス',
    password: 'パスワード',
    passwordConfirmation: 'パスワード(確認)',
    name: '名前',
    authority: '権限',
    authorityList: '権限一覧',
    screen: '画面',
    all: '全て',
    ShopWholeConfig: '店舗一括設定',
    editUser: 'ユーザー編集',
    deletionConfirmation: '削除します。よろしいでしょうか？',
    deleteUser: 'ユーザー削除',
  },
  orderPage: {
    lineup: '商品一覧',
    itemCsvUpload: '商品CSVアップロード',
    calorieCsvUpload: 'カロリーCSVアップロード',
    itemCsvDownload: '商品CSVダウンロード',
    calorieCsvDownload: 'カロリーCSVダウンロード',
    registrationConfirmation: '登録します。よろしいでしょうか？',
    imageDeletionConfirmationBefore: '',
    imageDeletionConfirmationAfter: '画像を削除します。よろしいでしょうか？',
    priceChange: '価格変動',
    applicable: '対象',
    notApplicable: '対象外',
    itemInformationRegistration: '商品情報登録',
    japanese: '日本語',
    english: '英語',
    traditionalChinese: '繁体中国語',
    simplifiedChinese: '簡体中国語',
    korean: '韓国語',
    productionLanguage1: 'ネタ名称_言語1',
    productionLanguage2: 'ネタ名称_言語2',
    productionLanguage3: 'ネタ名称_言語3',
    productionLanguage4: 'ネタ名称_言語4',
    productionLanguage5: 'ネタ名称_言語5',
    productionLanguage6: 'ネタ名称_言語6',
    productionLanguage7: 'ネタ名称_言語7',
    productionLanguage8: 'ネタ名称_言語8',
    productionLanguage9: 'ネタ名称_言語9',
    productionLanguage10: 'ネタ名称_言語10',
    itemCode: '商品コード',
    itemName: '商品名',
    displayMenu: 'メニュー表示',
    displayWide: 'ワイド表示',
    unitType: '提供単位',
    provideUnitId: '提供単位ID',
    toppingType: 'トッピング種類',
    typesOfGarnishments: 'トッピング種類',
    manufacturingDivisionId: '製造区分ID',
    tagTextString: 'タグ文字列',
    plate: '皿',
    piece_hon: '本',
    piece_ko: '個',
    cup: '杯',
    itemInformationUpload: '商品情報アップロード',
    itemInformationCsv: '商品情報CSV',
    editItemInformation: '商品情報修正',
    searchTagInformationUpload: '検索タグ情報アップロード',
    searchTagInformationCsv: '検索タグ情報CSV',
    deleteSearchTag: '検索タグの削除',
    itemImageUploadAttention:
      '※画像を選択するとすぐにアップロードされ、メニュー画像がその場で更新されますのでご注意ください',
    dragAndDropHere: 'ここにファイルをドラッグ&ドロップしてください',
    orSelectFile: 'またはファイルを選択',
    fileOverwriteAttention:
      '※同じ名前のファイルは上書きされますのでご注意ください',
    uploadImageList: 'アップロード画像リスト',
    successfulUploadItemImage: '商品画像のアップロードに成功しました。',
    pendingUploadItemImage: 'アップロードの準備中です。',
    processingUploadItemImage: 'アップロード中です…',
    invalidUploadItemImage: 'この種類のファイルには対応していません。',
    failureUploadItemImage: '商品画像のアップロードに失敗しました。',
    uploadAlert: '処理中の画像があります。移動しますか？',
    deleteItemImage: '画像の削除',
    searchSettings: '検索設定',
    item: '商品',
    tag: 'タグ',
    searchTag: '検索タグ',
    addTag: 'タグ追加',
    addSearchTag: '検索タグ追加',
    addShop: '店舗追加',
    tagId: 'タグID',
    searchTagName: '検索タグ名',
    searchTagInformation: '検索タグ情報',
    addItem: '商品追加',
    categoryList: 'カテゴリー一覧',
    categoryInformationRegistration: 'カテゴリー情報登録',
    inputConfirmation: '入力確認',
    registration: '登録',
    editCategoryInformation: 'カテゴリー情報編集',
    categoryDeletionConfirmationBefore: 'カテゴリー',
    categoryDeletionConfirmationAfter: 'を削除してもよろしいですか？',
    deleteCategoryBefore: 'カテゴリー',
    deleteCategoryAfter: 'の削除',
    changeCategoryDisplayOrder: 'カテゴリーの表示順の変更',
    createNewMenu: '新規作成',
    copyPublishedMenuNotice:
      '現在公開中のメニューを元に新規メニューを作成します。',
    noOpenMenu: '公開中のメニューがありません',
    createOpenMenu: '公開中のメニューを作成して下さい。',
    editDraft: '下書きを編集',
    editDraftNotice: '現在作成中のメニューを修正します。',
    editPublishedMenu: '公開中のメニューを編集',
    editPublishedMenuNotice: '現在公開中のメニューを修正します。',
    menuDraft: 'メニューの下書き',
    menuConfig: 'メニュー設定',
    editingTheMenuInOperation: '運用中のメニューを編集中',
    useStartTime: '利用開始日時',
    useEndTime: '利用終了日時',
    menuStatus: 'メニュー状態',
    draft: '下書き',
    inOperation: '運用中',
    inOperationMenu: '運用中のメニュー',
    preview: 'プレビュー',
    menuDisplay: 'メニュー表示',
    wideDisplay: 'ワイド表示',
    editingDraft: '下書きを編集中',
    tableNo: '番テーブル',
    call: '呼び出し',
    check: 'お会計',
    priceInformation: '価格情報',
    priceInformationList: '価格情報一覧',
    pricePatternId: '価格パターンID',
    pricePatternIdCsv: '価格パターンID',
    pricePatternName: '価格パターン名',
    pricePatternNameCsv: '価格パターン名',
    priceId: '価格ID',
    priceName: '名称',
    updateCategory: '更新区分',
    priceInformationUpload: '価格情報アップロード',
    priceInformationCsv: '価格情報CSV',
    itemCalorie: 'カロリー情報',
    itemCalorieUpload: 'カロリー情報アップロード',
    itemCalorieCsv: 'カロリー情報CSV',
  },
  adPage: {
    recommendOnOrderList: '注文時レコメンド一覧',
    recommendOnOrderRegistration: '注文時レコメンド登録',
    orderMenu: '注文メニュー',
    editRecommendOnOrder: '注文時レコメンド編集',
    recommendUpload: 'レコメンドアップロード',
    recommendCsv: 'レコメンドCSV',
    recommendOnOrderDeletionConfirmation:
      '注文時レコメンド情報を削除してもよろしいですか？',
    timedRecommendDeletionConfirmation:
      '時限式レコメンド情報を削除してもよろしいですか？',
    deleteRecommendOnOrder: '注文時レコメンド情報の削除',
    deleteTimedRecommend: '時限式レコメンド情報の削除',
    timedRecommendList: '時限式レコメンド一覧',
    timedRecommendRegistration: '時限式レコメンド登録',
    implementationTimingConditions: '実施タイミング条件',
    elapsedTime: '経過時間',
    minutesLater: '分後',
    timedRecommendImage: '時限式レコメンド画像',
    imageUploadDescription:
      '1MBまでのpngファイルか、jpgファイルをアップロードできます。',
    recommendPeriod: 'レコメンド期間',
    recommendPeriodStart: 'レコメンド期間(開始日)',
    recommendPeriodEnd: 'レコメンド期間(終了日)',
    fromTheFirstOrder: '最初の注文から',
    fromTheLastOrder: '最後の注文から',
    immediatelyAfterAuthentication: '認証直後',
    editTimedRecommend: '時限式レコメンド編集',
    itemIsYetNotRegistered: '商品がまだ登録されていません',
  },
  eventInformationPage: {
    deleteEventInformation: 'イベント情報の削除',
    eventRegistration: 'イベント登録',
    editEvent: 'イベント編集',
    postingTerm: '掲載期間',
    postingTermStart: '掲載期間（開始日）',
    postingTermEnd: '掲載期間（終了日）',
    startDate: '開始日',
    yearsMonthDate: '年/月/日',
    endDate: '終了日',
    decisionTiming: '判定タイミング',
    whenSeatAuthentication: '座席認証時',
    whenOrder: '注文時',
    eventConditions: 'イベント条件',
    birthMonth: '誕生月',
    visitInBirthMonth: '誕生月に来店した',
    operationAtConditionCoincidence: '条件合致時の動作',
    gachadamaEmission: 'ガチャ玉排出',
    bikkuraponLottery: 'ビッくらポン抽選',
    optionalVideo: '任意の動画',
    videoName: '動画名',
    shopGroupList: '店舗グループ一覧',
    groupId: 'グループID',
    groupName: 'グループ名',
    userAttribute: 'ユーザー属性',
    emission: '排出',
    lottery: '抽選',
    video: '動画',
    eventInformationDeletionConfirmation:
      'イベント情報を削除してもよろしいですか？',
  },
  operationalManagementPage: {
    soOrderLimitCountAttention:
      'SO注文制限件数のテキストボックスに値を入力した場合、全ての店舗の各制限件数が更新されますのでご注意下さい。\n店舗ごとに各制限件数を更新しない場合は、テキストボックスに何も入力しないでください。',
    orderLimit: 'SO注文数制限件数',
    orderLimitShop: 'SO注文数制限件数（店舗）',
    orderLimitTable: 'SO注文数制限件数（テーブル）',
    orderLimitPreOrder: 'SO注文数制限件数（事前注文）',
    itemMinMax: '件数(0~99)',
    table: 'テーブル',
    preOrder: '事前注文',
    soOperationAttention:
      '運用は基本的に「運用」として、事情によりすべての店舗でSO運用を一時停止（または再開）する場合に切り替えてください。\nSO運用が「運用」である場合、店舗ごとのSO運用の設定が優先されます。',
    soOperation: 'SO運用',
    bikkuraponRateChange: 'ビッくらポン確率変動',
    priceDisplay: '価格表示',
    bikkuraponIconDisplay: 'ビッくらポンアイコン表示',
    kuraCode: 'くら寿司店舗コード',
    shopName: '店舗名',
    eparkGourmetId: 'EPARKグルメID',
    eparkTakeoutId: 'EPARKテイクアウトID',
    lastOrder: 'ラストオーダー',
    tableCount: '店舗卓数',
    shopLimitNumber: '店舗制限数',
    soOperationalStatus: 'SO運用状況',
    selfCheckOperationalStatus: 'セルフチェック運用状況',
    shopConfig: '店舗設定',
    qrForSeat: '座席用QR',
    qrCodeDisplayForSeatAuthorization: '座席認証用QRコード表示',
    wholeSelection: '全体選択',
    wholeDeselection: '全体選択解除',
    printSelectedQr: '選択したQRを印刷する',
    soWebSupportedVersion: 'SOWeb対応版（新仕様）',
    appVersion: 'アプリ版（旧仕様）',
    shopNumber: '店番号',
    seatNumber: '席番号',
    changeQr: 'QR変更',
    qrCodeIsUnselected: 'QRコードが未選択です。',
    qrCodeUnset: 'のQRコードが設定されていません。',
    ofQrCode: 'のQRコード',
    qrCodeChange: 'QRコードの変更',
    qrCodePrinting: 'QRコード印刷',
    shopInformation: '店舗情報',
    shopInformationRegistration: '店舗情報登録',
    editShopInformation: '店舗情報編集',
    priceBand: '価格帯',
    numberOfSeats: '座席数',
    gourmetShopId: 'グルメ店舗ID',
    takeOutShopId: 'テイクアウト店舗ID',
    soOrderLimit: 'SO注文制限',
    soOrderLimitAllSeats: 'SO注文制限（店舗全体）',
    soOrderLimitTable: 'SO注文制限（テーブル）',
    soOrderLimitPreOrder: 'SO注文制限（事前注文）',
    allSeats: '店舗全体',
    selfcheckOperation: 'セルフチェック運用',
    shopInformationUpload: '店舗情報アップロード',
    shop: '店舗',
    group: 'グループ',
    addGroup: 'グループ追加',
    shopGroupInformationUpload: '店舗グループ情報アップロード',
    shopGroupInformation: '店舗グループ情報',
    addShopGroup: '店舗グループ追加',
    deleteShopGroup: '店舗グループの削除',
    update: '更新',
    globalSettings: '全体設定',
    stopping: '停止中',
    emissionSetting: '排出設定',
    numberOfTimes: '回数',
    probability: '確率',
    individualSetting: '個別設定',
    bikkuraponInstallation: 'ビッくらポン設置',
    amountOfMoney: '金額',
    rotation: '回数(回)',
    probabilityPercent: '確率(%)',
    notInstalled: '未設置',
    off: '無',
    on: '有',
  },
}

export default ja
